import axios from 'axios'

import { ChanneledRequestParams, Department } from 'modules/Monitoring/types'

export const getDepartments = async (params: ChanneledRequestParams) => {
  return (
    await axios.get<Department[]>('/departments', {
      params,
    })
  ).data
}
